var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:'tag ' + _vm.getOrderStatus().color},[_vm._v("\n  "+_vm._s(_vm.getOrderStatus().text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }